// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"BookingEngineConfiguration_cardContainer__38ZM9","margin":"BookingEngineConfiguration_margin__XrvVQ"};